<template>
  <div class="mobile-card" :class="{ 'mobile-card--inativo': item.flagebook === 'F' }">

    <div class="mobile-card-header">
      <div>
        <span class="mobile-pedido">Pedido #{{ item.idorcamento }}</span>
        <span class="mobile-filial">{{ item.empresa || item.idempresa }} · {{ parseDtPedido(item.dtpedido).data }} {{ parseDtPedido(item.dtpedido).hora }}</span>
      </div>
      <div class="d-flex align-center gap-6">
        <v-chip :color="statusPedido.color" x-small dark style="font-weight:600; margin-right:4px;">
          {{ statusPedido.label }}
        </v-chip>
        <v-chip x-small :color="corCombo" dark style="font-weight:600;">
          {{ item.combo }}
        </v-chip>
      </div>
    </div>

    <div class="mobile-card-body">
      <div class="mobile-field">
        <span class="mobile-label">Cliente</span>
        <span class="mobile-value">{{ item.nomecliente }}</span>
      </div>
      <div class="mobile-field">
        <span class="mobile-label">Vendedor</span>
        <span class="mobile-value">{{ item.nomevendedor }}</span>
      </div>
      <div class="mobile-field">
        <span class="mobile-label">Valor E-book</span>
        <span class="mobile-value mobile-value--destaque">{{ item.valorebook | formataDinheiro }}</span>
      </div>
      <div class="mobile-field">
        <span class="mobile-label">Valor Total</span>
        <span class="mobile-value">{{ item.vlrtotal | formataDinheiro }}</span>
      </div>
    </div>

    <div class="mobile-card-footer">

      <!-- Linha 1: ações principais (Remover + Autorizar) -->
      <div
          v-if="permissao('wolihub_remover_ebook') || permissao('wolihub_autorizar_devolucao')"
          class="mobile-acoes-grid"
      >
        <v-btn
            v-if="permissao('wolihub_remover_ebook')"
            small color="error" outlined
            :disabled="item.flagebook === 'F' || item.flagefetivado === 'T'"
            class="mobile-acao-btn"
            @click="$emit('remover', item)"
        >
          <v-icon small left>mdi-book-remove</v-icon>
          Remover
        </v-btn>

        <v-btn
            v-if="permissao('wolihub_autorizar_devolucao')"
            small outlined
            :color="item.flagautorizado === 'T' ? 'teal' : 'primary'"
            :disabled="!podeAutorizar"
            class="mobile-acao-btn"
            @click="$emit('autorizar', item)"
        >
          <v-icon small left>
            {{ item.flagautorizado === 'T' ? 'mdi-shield-check-outline' : 'mdi-book-check-outline' }}
          </v-icon>
          {{ item.flagautorizado === 'T' ? 'Autorizado' : 'Autorizar' }}
        </v-btn>
      </div>

      <!-- Linha 2: Ver Detalhes + Ver Produtos + Comprovante -->
      <div
          v-if="permissao('wolihub_ver_detalhes') || permissao('wolihub_lista_produto') || permissao('wolihub_imprimir_comprovante')"
          class="mobile-acoes-grid"
      >
        <v-btn
            v-if="permissao('wolihub_ver_detalhes')"
            small outlined color="indigo"
            class="mobile-acao-btn"
            @click="$emit('detalhes', item)"
        >
          <v-icon small left>mdi-information-outline</v-icon>
          Detalhes
        </v-btn>

        <v-btn
            v-if="permissao('wolihub_lista_produto')"
            small outlined color="primary"
            class="mobile-acao-btn"
            @click="$emit('expandir', item)"
        >
          <v-icon small left>
            {{ expandido ? 'mdi-package-variant' : 'mdi-package-variant-closed' }}
          </v-icon>
          {{ expandido ? 'Recolher' : 'Produtos' }}
        </v-btn>

        <v-btn
            v-if="permissao('wolihub_imprimir_comprovante')"
            small outlined color="primary"
            class="mobile-acao-btn"
            :loading="gerandoPDF"
            @click="$emit('comprovante', item)"
        >
          <v-icon small left>mdi-printer-outline</v-icon>
          Comprovante
        </v-btn>
      </div>

    </div>

    <!-- Seção expandida -->
    <v-expand-transition>
      <div v-if="permissao('wolihub_lista_produto') && expandido" class="mobile-expanded">
        <div v-if="carregandoProdutos" class="mobile-expanded-loading">
          <v-progress-circular indeterminate size="16" width="2" color="primary" class="mr-2" />
          Carregando produtos...
        </div>
        <div v-else-if="produtos.length" class="mobile-produto-lista">
          <div
              v-for="(p, pi) in produtos"
              :key="pi"
              class="mobile-produto-item"
          >
            <span class="mobile-produto-nome">{{ p.produto }}</span>
            <div class="mobile-produto-info">
              <span>Qtd: <strong>{{ p.quantidade }}</strong></span>
              <span>Total: <strong>{{ p.vlrtotal | formataDinheiro }}</strong></span>
            </div>
          </div>
        </div>
        <div v-else class="mobile-expanded-vazio">
          <v-icon size="16" color="grey lighten-2" class="mr-1">mdi-package-variant-outline</v-icon>
          Nenhum produto encontrado.
        </div>
      </div>
    </v-expand-transition>

  </div>
</template>

<script>
export default {
  name: 'PedidoCardMobile',

  props: {
    item:             { type: Object,  required: true },
    statusPedido:     { type: Object,  default: () => ({}) },
    corCombo:         { type: String,  default: 'grey' },
    expandido:        { type: Boolean, default: false },
    carregandoProdutos: { type: Boolean, default: false },
    produtos:         { type: Array,   default: () => [] },
    gerandoPDF:       { type: Boolean, default: false },
    podeAutorizar:    { type: Boolean, default: false },
    parseDtPedido:    { type: Function, required: true },
  },

  emits: ['remover', 'autorizar', 'detalhes', 'expandir', 'comprovante'],
}
</script>

<style scoped>
.gap-6 { gap: 6px; }

.mobile-card {
  margin: 8px;
  border: 1px solid #dde6ee;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}
.mobile-card--inativo { opacity: 0.65; }

.mobile-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  background: #f5f8fa;
  border-bottom: 1px solid #eef2f6;
  gap: 8px;
}
.mobile-pedido { display: block; font-size: 13px; font-weight: 700; color: #023449; }
.mobile-filial { display: block; font-size: 11px; color: #8fa8bc; }

.mobile-card-body {
  padding: 10px 12px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}
.mobile-field   { display: flex; flex-direction: column; gap: 2px; }
.mobile-label   { font-size: 9px; color: #8fa8bc; font-weight: 600; text-transform: uppercase; letter-spacing: 0.3px; }
.mobile-value   { font-size: 12px; color: #3d5166; }
.mobile-value--destaque { color: #023449; font-weight: 700; }

.mobile-card-footer {
  padding: 8px 12px;
  border-top: 1px solid #eef2f6;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.mobile-acoes-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
}

.mobile-acao-btn {
  border-radius: 8px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 11px !important;
  letter-spacing: 0 !important;
  height: 32px !important;
}

/* ── Expandido mobile ──────────────────────────────────────────────────── */
.mobile-expanded { border-top: 1px solid #eef2f6; background: #f5f9fc; }
.mobile-expanded-loading { display: flex; align-items: center; padding: 10px 12px; font-size: 12px; color: #5a6a7a; }
.mobile-produto-lista { padding: 2px 0; }
.mobile-produto-item { padding: 8px 12px; border-bottom: 1px solid #eef2f6; }
.mobile-produto-item:last-child { border-bottom: none; }
.mobile-produto-nome { display: block; font-size: 12px; font-weight: 600; color: #023449; margin-bottom: 3px; }
.mobile-produto-info { display: flex; gap: 14px; font-size: 11px; color: #8fa8bc; }
.mobile-expanded-vazio { display: flex; align-items: center; padding: 10px 12px; font-size: 12px; color: #b0bec5; }
</style>
